/**
 * ThemeToggle — the user's Light/Dark switch.
 *
 * A5: it is a real button (≥40px), it is labelled, and the current state is
 * communicated by the icon AND the accessible label, never by colour alone.
 */
import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";

export function ThemeToggle({ variant = "icon", className = "" }) {
  const { isDark, toggleTheme } = useTheme();
  const label = isDark ? "Passa al tema chiaro" : "Passa al tema scuro";
  const Icon = isDark ? Sun : Moon;

  if (variant === "inline") {
    return (
      <button
        type="button"
        data-testid="theme-toggle"
        aria-label={label}
        title={label}
        onClick={toggleTheme}
        className={`inline-flex items-center gap-2 h-10 px-3 rounded-lg border border-line
                    bg-surface text-content-secondary hover:bg-surface-subtle hover:text-content
                    transition-colors duration-base ease-system text-sm ${className}`}
      >
        <Icon className="w-4 h-4" aria-hidden="true" />
        <span data-testid="theme-toggle-label">{isDark ? "Tema scuro" : "Tema chiaro"}</span>
      </button>
    );
  }

  return (
    <button
      type="button"
      data-testid="theme-toggle"
      aria-label={label}
      title={label}
      onClick={toggleTheme}
      className={`inline-flex items-center justify-center w-10 h-10 rounded-lg border border-line
                  bg-surface text-content-secondary hover:bg-surface-subtle hover:text-content
                  transition-colors duration-base ease-system ${className}`}
    >
      <Icon className="w-4 h-4" aria-hidden="true" />
    </button>
  );
}

export default ThemeToggle;
